import { render } from "./OAuthConnect.vue?vue&type=template&id=5f48704d&ts=true"
import script from "./OAuthConnect.vue?vue&type=script&lang=ts"
export * from "./OAuthConnect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/connect-widgets/connect-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__